<template>
  <div id="howitworks" class="d-flex justify-content-center">
    <div class="container-fluid">
      <div class="row ">
        <div class="col-md-12 mb-4">
          <h2 class="text-center">How It Works</h2>
          <hr>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-10">
          <img src="../assets/Picture4.png" class="img-fluid" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#howitworks{
  background-color:#1f1f1e !important;
  padding:6em 0
}
h2{
  font-size: 2em;
  font-weight: 800;
  color: #fff;
}
hr{
  height: 2px;
  background-color:red;
  width:100px;
}
</style>